<template>
  <BaseAction>
    <PrimaryButton @click.native="openDialog" light shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <SubmitFeedbackDialog
      :feedback="feedback"
      editMode
      v-if="isDialogOpen"
      :isOpen="isDialogOpen"
      @close="closeDialog"
    />
  </BaseAction>
</template>

<script>
import SubmitFeedbackDialog from "@/views/interviews/dialogs/SubmitFeedback/SubmitFeedbackDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "EditFeedbackAction",
  components: {
    BaseAction,
    PrimaryButton,
    SubmitFeedbackDialog
  },
  props: {
    feedback: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
